import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CollapsiblePanelComponent from './../Components/CollapsiblePanelComponent.jsx';

export default class CollapsiblePanelContainer extends Component {
  static propTypes = { expanded: PropTypes.bool };

  constructor(props) {
    super(props);
    this.state = { expanded: this.props.expanded || false };
  }

  onToggle() {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    return (
      <CollapsiblePanelComponent
        {...this.props}
        expanded={this.state.expanded}
        onToggle={() => this.onToggle()}
      />
    );
  }
}


// WEBPACK FOOTER //
// src/Containers/CollapsiblePanelContainer.jsx